var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCertificate = props => /*#__PURE__*/React.createElement("svg", _extends({
  color: "#0C9",
  width: 24,
  height: 32,
  viewBox: "0 0 24 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.708 15.708a1.001 1.001 0 0 0-1.416-1.416L11 19.586l-2.292-2.294a1.001 1.001 0 1 0-1.416 1.416l3 3a1 1 0 0 0 1.416 0l6-6Z",
  fill: "currentcolor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24 28V9l-9-9H4a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4ZM15 6a3 3 0 0 0 3 3h4v19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h11v4Z",
  fill: "currentcolor"
})));
export default SvgCertificate;